// Index file for the directory. Don't add anything else here.
import CarouselUserJourney from './CarouselUserJourney';
export default CarouselUserJourney;
